import { parseHtml } from "@components/HTMLParser/utils";

interface IHTMLParserProps {
  html: string;
}

export const HTMLParser: React.FC<IHTMLParserProps> = ({ html }) => {
  return <>{parseHtml(html)}</>;
};
